<template>
  <div>
    <div class="text-h5">Verpacken</div>
    <br><br>

    <v-alert
        v-for="(e, idx) in log"
        :key="idx"
        :type="e.code === 'ok' ? 'success' : 'error'"
        prominent
    >
      <v-row align="center">
        <v-col class="grow">
          {{ e.message }}
        </v-col>
        <v-col class="shrink" v-if="e.data && e.data.actions">
          <nobr>
            <v-btn
                v-for="(action, aidx) in e.data.actions"
                :key="aidx"
                color="primary"
                @click="runAction(action)"
                class="mb-3"
            >
              <template v-if="action.type === 'printShipment'">
                <v-icon left dark>mdi-printer</v-icon> Lieferschein
              </template>
              <template v-else-if="action.type === 'printInvoice'">
                <v-icon left dark>mdi-printer</v-icon> Rechnung
              </template>
              <template v-else>
                {{ action.type }}
              </template>
            </v-btn>
          </nobr>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';

export default {
  name: 'OrderProduced',
  data() {
    return {
      log: []
    }
  },
  methods: {
    scancode(data) {
      console.log('[OrderProduced] scancode called with:', data);
      if (data.type !== 'document') {
        console.warn('[OrderProduced] invalid scan type:', data.type);
        return this.alert({ type: 'error', message: 'Dieser Code kann auf dieser Seite nicht verwendet werden' });
      }

      const postData = { [`${data.documentType}Id`]: data.id };
      console.log('[OrderProduced] sending orderProduced with:', postData);
      this.runAction({ type: 'orderProduced', data: postData });
    },

    alert(data) {
      console.log('[OrderProduced] alert log entry:', data);
      this.log.unshift(data);
    },

    runAction(action) {
      console.log('[OrderProduced] runAction:', action);
      this.$axios
          .post(`/api/work/${action.type}`, action.data)
          .then((response) => {
            console.log(`[OrderProduced] ${action.type} response:`, response.data);
            this.alert(response.data);
          })
          .catch((error) => {
            console.error(`[OrderProduced] ${action.type} error:`, error);
            // Track error in Sentry if it's initialized
            if (this.$env.VUE_APP_SENTRY_DSN && this.$env.VUE_APP_SENTRY_DSN.trim() !== '') {
              Sentry.captureException(error);
            }

            // Try to get the error message from the server response
            let errorMessage = 'Netzwerkfehler beim Ausführen der Aktion';
            if (error.response && error.response.data) {
              if (error.response.data.message) {
                errorMessage = error.response.data.message;
              } else if (error.response.data.error) {
                errorMessage = error.response.data.error;
              }
            }

            this.alert({ type: 'error', message: errorMessage });
          });
    }
  }
}
</script>
